import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { TreeTable } from 'primeng/treetable';
import { Checkbox } from 'primeng/checkbox';
import { NavigationExtras, Router } from '@angular/router';
import { FilterScheduleData, FilterScheduleDate } from '../../../../models/filter-schedule-data';
import { DatePipe } from '@angular/common';
import { ScheduleService } from '../../../../service/schedule/schedule.service';
import { FrappeApp } from 'frappe-js-sdk';
import { environment } from '../../../../../environments/environment';
import { ScheduleFieldsDTOForSchedule,PoFieldsDTOForSchedule,ItemFieldsDTOForSchedule } from '../../../../models/schedule-SearchDTO';

interface Column {
  field: string;
  filterMatchMode: string;
  defaultFilter: string;
}

interface ItemWithSchedule {
  item_no: string,
  material_code: string,
  description: string,
  delivery_date: string,
  quantity: number,
  uom: string,
  status: string,
  poagreement_no: string,
  plant_code: string,
  poagreementNo: string,
  plant: string,
  plant1: string,

}
interface ItemWithState extends ItemWithSchedule {
  checked: boolean;
}

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrl: './schedule.component.scss'
})
export class ScheduleComponent implements OnInit {
  @ViewChild('tt') tt?: TreeTable;
  @ViewChildren('checkbox') checkboxes!: QueryList<Checkbox>;

  expandedOrder: boolean = false;
  filterMode = 'lenient';
  visible: boolean = false;

  poList?: any[];

  mappedData: any[] = [];
  shipmentCreatedMap?: any[] = [];
  shipmentPendingMap?: any[] = [];
  isShipmentCreatedMap=false
  isShipmentPendingMap=true


  cols!: Column[];
  cols1!: Column[];
  selectedRows: any[] = [];
  item_nos: any;

  isContentVisible = false;

  companyCode: string = '';
  plant: string = '';
  docType: string = '';
  docCat: string = '';
  poAgreementNo: string = '';
  vendorCode: string = '';
  status: string = '';
  documentDate: Date | undefined;
  deliveryDate: Date | undefined;
  filterSchiduleData!: FilterScheduleData;
  filterDate!: FilterScheduleDate;
  private frappe: FrappeApp
  defaultStatusFilter: string = 'Open';

  selectedPOData: any[] = []
  selectedPOScheduleData: any[] = []
  po_no: string = '';
  schedule_item_no: string = '';
  sidebarVisible: boolean = false;
  itemno: string = '';
  isLoading: boolean = false;
  limit:number=10;
  currentPage:number=1;
  totalRecords:number=0
  scheduleSearchDTO?:ScheduleFieldsDTOForSchedule
  poSearchDTO?:PoFieldsDTOForSchedule
  itemSearchDTO?:ItemFieldsDTOForSchedule

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private scheduleService: ScheduleService

  ) {
    this.filterSchiduleData = new FilterScheduleData()
    this.filterDate = new FilterScheduleDate()
    this.scheduleSearchDTO= new ScheduleFieldsDTOForSchedule()
    this.poSearchDTO= new PoFieldsDTOForSchedule()
    this.itemSearchDTO= new ItemFieldsDTOForSchedule()
    this.frappe = new FrappeApp(environment.FRAPPE_API_URL);
  }

  ngOnInit() {
    this.getSFSList();
    // this.fetchData();
    this.allFetchData()
    this.initializeColumns();
    this.initializeColumns1();

    const selectedNo = history.state.selectedNo;
    if (selectedNo) {
      this.itemno = selectedNo;
      this.fetchData().then(() => {
        history.replaceState({ ...history.state, selectedNo: null }, '');
      });
    }
  }

  onPageChange(event:any){
    this.currentPage=event.page + 1
    this.limit=event.rows
    // this.fetchData()
    this.allFetchData()
  }

  showDialog() {
    this.visible = true;
  }

  newMappedData: any[] = [];
  shipmentPendingList:any[]=[];
  shipmentCreatedList:any[]=[];

  selectedVendor:any [] =[];

  allFetchData(){
    try{
      let status="";
      if (this.isShipmentPendingMap) {
        // if (this.scheduleSearchDTO) {
        //   this.scheduleSearchDTO.status = "Shipment Pending";
        // }
        status ="Shipment Pending"
      }else if (this.isShipmentCreatedMap) {
        // if (this.scheduleSearchDTO) {
        //   this.scheduleSearchDTO.status = "Shipment Created";
        // }
        status ="Shipment Created"
      }
      let data={
        page:this.currentPage,
        limit:this.limit,
        status:status,
        schedule_search_dto:this.scheduleSearchDTO,
        po_search_dto:this.poSearchDTO,
        item_search_dto:this.itemSearchDTO
      }
      this.isLoading=true
      this.scheduleService.getPageableScheduleList(data).then((res)=>{
        this.isLoading=false
        this.poList = res.message.schedule_response_list;
        this.totalRecords = res.message.total_record;
        if (this.poList !== undefined) {
          this.mappedData = this.poList.sort((a: any, b: any) => this.compareItemNo(a.item_no, b.item_no)).map((poData: any, index: any) => {
            return {
              key: `parent_${index}`,
              data: {
                vendor_code: poData.vendor_code,
                status: poData.status,
                item_no:poData.item_no,
                poagreement_no: poData.poagreement_no,
                material_code: poData.material_code,
                description: poData.description,
                delivery_date: this.formatDate(poData.delivery_date),
                quantity: poData.quantity,
                uom: poData.uom,
                plant: poData.plant,
              }
            }
          });
        }
      }).catch((error)=>{
        this.isLoading=false
        console.log(error)
      })

      if (this.mappedData.length > 0) {
        this.mappedData.forEach((parent) => {
          if (parent.parent != null) {
            parent.children.forEach((child: ItemWithState) => {
              child.checked = false;
            });
          }
        });
      }
      if (this.itemno) {
        this.mappedData = this.mappedData?.filter(parent => {
          parent.children = parent.children.filter((child: { data: { itemNo: string; }; }) => {
            return child.data.itemNo === this.itemno;
          });
          return parent.children.length > 0;
        });
      }

    }catch (error) {
      this.isLoading=false
      console.error("Error fetching data:", error);
    }
  }

 async fetchData() {
    try {
      await this.scheduleService.getScheduleList().then((res) => {
        this.poList = res.message;
        if (this.poList !== undefined) {
          this.mappedData = this.poList.map((poData: any, index: any) => {
            return {
              key: `parent_${index}`,
              data: {
                itemNo: poData.plant,
                plant: poData.poagreementNo,
                pono: this.formatDate(poData.documentDate),
                ddate: poData.vendorCode,
                vcode: poData.name,
                name: poData.status,
              },
              children: poData.itemsWithSchedules.sort((a: any, b: any) => this.compareItemNo(a.itemNo, b.itemNo))
                .map((itemScheduleData: any, childIndex: any) => {
                  if (itemScheduleData.status === "Shipment Pending") {
                      itemScheduleData.plant=poData.plant
                      this.shipmentPendingList.push(itemScheduleData)
                  }else if (itemScheduleData.status === "Shipment Created") {
                    itemScheduleData.plant=poData.plant
                    this.shipmentCreatedList.push(itemScheduleData)
                  }

                  return {
                    key: `child_${index}_${childIndex}`,
                    data: {
                      itemNo: itemScheduleData.itemNo,
                      poagreementNo: itemScheduleData.poagreementNo,
                      vendorCode: itemScheduleData.vendorCode,
                      plant: itemScheduleData.materialCode,
                      pono: itemScheduleData.description,
                      ddate: this.formatDate(itemScheduleData.deliveryDate),
                      vcode: itemScheduleData.quantity,
                      name: itemScheduleData.uom,
                      status: itemScheduleData.status
                    }
                  }
                })
            }
          });
        }
      })
      if (this.mappedData) {
        this.mappedData.forEach((parent) => {
          parent.children.forEach((child: ItemWithState) => {
            child.checked = false;
          });
        });
      }
      this.fetchData2()
      if (this.itemno) {
        this.mappedData = this.mappedData?.filter(parent => {
          parent.children = parent.children.filter((child: { data: { itemNo: string; }; }) => {
            return child.data.itemNo === this.itemno;
          });
          return parent.children.length > 0;
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  async fetchData2() {
    try {
      // await this.scheduleService.getScheduleList().then((res) => {
      //   this.poList = res.message;
        if (this.shipmentPendingList != null) {
          this.shipmentPendingMap = this.shipmentPendingList.map((poData: any, index: any) => {
            return {
              key: `parent_${index}`,
              data: {
                action:'',
                itemNo: poData.itemNo,
                poagreementNo: poData.poagreementNo,
                vendorCode: poData.vendorCode,
                plant: poData.materialCode,
                pono: poData.description,
                ddate: this.formatDate(poData.deliveryDate),
                vcode: poData.quantity,
                name: poData.uom,
                status: poData.status,
                plant1:poData.plant
              }
              // children: poData.itemsWithSchedules.sort((a: any, b: any) => this.compareItemNo(a.itemNo, b.itemNo))
              //   .map((itemScheduleData: any, childIndex: any) => {
              //     this.newMappedData.push(itemScheduleData)
              //     return {
              //       key: `child_${index}_${childIndex}`,
              //       data: {
              //         itemNo: itemScheduleData.itemNo,
              //         poagreementNo: itemScheduleData.poagreementNo,
              //         vendorCode: itemScheduleData.vendorCode,
              //         plant: itemScheduleData.materialCode,
              //         pono: itemScheduleData.description,
              //         ddate: this.formatDate(itemScheduleData.deliveryDate),
              //         vcode: itemScheduleData.quantity,
              //         name: itemScheduleData.uom,
              //         status: itemScheduleData.status,
              //       }
              //     }
              //   })
            }
          });
          // const statusColumn = this.cols.find((col: any) => col.field === 'status')
          // if (statusColumn) {
          //   statusColumn.defaultFilter = this.defaultStatusFilter;
          // }
          // this.setDefualt()
        }if (this.shipmentCreatedList !=null) {
          this.shipmentCreatedMap = this.shipmentCreatedList.map((poData: any, index: any) => {
            return {
              key: `parent_${index}`,
              data: {
                itemNo: poData.itemNo,
                poagreementNo: poData.poagreementNo,
                vendorCode: poData.vendorCode,
                plant: poData.materialCode,
                pono: poData.description,
                ddate: this.formatDate(poData.deliveryDate),
                vcode: poData.quantity,
                name: poData.uom,
                status: poData.status,
              }
            }
          });
        }
      // })
      if (this.mappedData) {
        this.mappedData.forEach((parent) => {
          parent.children.forEach((child: ItemWithState) => {
            child.checked = false;
          });
        });
      }

      if (this.itemno) {
        this.mappedData = this.mappedData?.filter(parent => {
          parent.children = parent.children.filter((child: { data: { itemNo: string; }; }) => {
            return child.data.itemNo === this.itemno;
          });
          return parent.children.length > 0;
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  setButton(rowData: any): boolean {
    if (rowData.node.key.startsWith('parent')) {
      return true
    }
    else {
      return false
    }
  }

  async filterScheduleData() {
    this.filterSchiduleData!.company_code = this.companyCode
    this.filterSchiduleData!.plant = this.plant,
      this.filterSchiduleData!.doc_type = this.docType,
      this.filterSchiduleData!.doc_cat = this.docCat,
      this.filterSchiduleData!.poagreement_no = this.poAgreementNo,
      this.filterSchiduleData!.vendor_code = this.vendorCode,
      this.filterSchiduleData!.document_date = this.documentDate,
      this.filterSchiduleData!.status = this.status
    this.filterDate!.delivery_date = this.deliveryDate

    const filterScheduleDate: any = {};
    if (this.deliveryDate) {
      filterScheduleDate.delivery_date = this.datePipe.transform(this.deliveryDate, 'yyyy-MM-dd');
      this.filterDate!.delivery_date = filterScheduleDate.delivery_date;
    }
    if (this.documentDate) {
      filterScheduleDate.document_date = this.datePipe.transform(this.documentDate, 'yyyy-MM-dd');
      this.filterSchiduleData!.document_date = filterScheduleDate.document_date;
    }
    const test = this.getFilteredData(this.filterSchiduleData);
    const test1 = this.getFilteredData(this.filterDate);
    try {
      await this.scheduleService.getFilterScheduleList(test, test1).then((res) => {
        this.poList = res.message;
        if (this.poList !== undefined) {
          this.mappedData = this.poList.map((poData: any, index: any) => {
            return {
              key: `parent_${index}`,
              data: {
                itemNo: poData.plant,
                plant: poData.poagreementNo,
                pono: this.formatDate(poData.documentDate),
                ddate: poData.vendorCode,
                vcode: poData.name,
                name: poData.status,
              },
              children: poData.itemsWithSchedules.sort((a: any, b: any) => this.compareItemNo(a.itemNo, b.itemNo)).map((itemScheduleData: any, childIndex: any) => {
                return {
                  key: `child_${index}_${childIndex}`,
                  data: {
                    itemNo: itemScheduleData.itemNo,
                    plant: itemScheduleData.materialCode,
                    pono: itemScheduleData.description,
                    ddate: this.formatDate(itemScheduleData.deliveryDate),
                    vcode: itemScheduleData.quantity,
                    name: itemScheduleData.uom,
                    status: itemScheduleData.status
                  }
                }
              })
            }
          });
        }
      })
      if (this.mappedData) {
        this.mappedData.forEach((parent) => {
          parent.children.forEach((child: ItemWithState) => {
            child.checked = false;
          });
        });
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  getFilteredData(filterValidation?: any) {
    const filteredSchiduleData: any = {}
    for (const key in filterValidation) {
      if (filterValidation[key] !== '' && filterValidation[key] !== undefined && filterValidation[key] !== null) {
        filteredSchiduleData[key] = filterValidation[key];
      }
    }
    return filteredSchiduleData;
  }

  compareItemNo(a: string, b: string): number {
    const hasUnderscoreA = a.includes('_');
    const hasUnderscoreB = b.includes('_');

    if (hasUnderscoreA && hasUnderscoreB) {
      const [prefixA, numberA] = a.split('_');
      const [prefixB, numberB] = b.split('_');

      const prefixComparison = prefixA.localeCompare(prefixB);

      if (prefixComparison !== 0) {
        return prefixComparison;
      }

      const numberComparison = parseInt(numberA, 10) - parseInt(numberB, 10);
      return numberComparison;
    } else {
      const numericComparison = parseInt(a, 10) - parseInt(b, 10);
      return numericComparison;
    }
  }

  formatDate(dateString: string) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0'); // Pad with leading zero if single digit
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Pad with leading zero if single digit
    const year = date.getFullYear();
    const formattedDate = `${day}.${month}.${year}`;
    return formattedDate;
  }


  initializeColumns() {
    this.cols = [
      { field: 'action', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'vendor_code', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'status', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'item_no', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'poagreement_no', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'material_code', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'description', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'delivery_date', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'quantity', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'uom', filterMatchMode: 'contains', defaultFilter: '' },
      // { field: 'plant', filterMatchMode: 'contains', defaultFilter: '' },
    ];
  }
  initializeColumns1() {
    this.cols1 = [
      { field: 'vendor_code', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'status', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'item_no', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'poagreement_no', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'material_code', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'description', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'delivery_date', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'quantity', filterMatchMode: 'contains', defaultFilter: '' },
      { field: 'uom', filterMatchMode: 'contains', defaultFilter: '' },
      // { field: 'plant', filterMatchMode: 'contains', defaultFilter: '' },
    ];
  }
  onInputChange(event: any, field: string) {
    const inputValue = (event.target as HTMLInputElement)?.value;
    if ("delivery_date" == field || "item_no" == field ||"quantity" == field) {
      (this.scheduleSearchDTO as any)[field] = inputValue;
    }
    else if ("poagreement_no" == field || "vendor_code" == field) {
      (this.poSearchDTO as any)[field] = inputValue;
    }
    else if ("description" == field || "material_code" == field || "uom" == field) {
      (this.itemSearchDTO as any)[field] = inputValue;
    }
    this.currentPage=1
    this.allFetchData()
    // this.tt?.filter(inputValue, field, 'contains');
  }

  onCheckboxChange(event: any, rowData: any) {
    // rowData.poagreement_no = rowData.poagreementNo
    // rowData.plant_code = rowData.plant
    rowData.checked = event.checked;
    if (event.checked) {
      this.selectedRows.push(rowData);
    } else {
      this.selectedRows = this.selectedRows.filter(row => row !== rowData);
    }
  }


  async getSFSList() {
    try {
      const getSFSList = await this.frappe.call().get('vendor_portal.api.shipment_asn.get_shipment_asn_list');
      this.item_nos = getSFSList.message.flatMap((item: { item_nos: any; }) => item.item_nos);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  // isItemNoInList(itemNo: string): boolean {
  //   return this.item_nos?.includes(itemNo) ?? false;
  // }
  isItemNoInList(itemNo: any): boolean {
    if (itemNo.status === 'Shipment Created') {
      return true;
    }
    return false;
  }

  addToShipment() {

    this.checkboxes.forEach(checkbox => {
      checkbox.writeValue(false);
    });
    this.createShipmentASN()
  }

  toggleContentVisibility(): void {
    this.isContentVisible = !this.isContentVisible;
  }

  createShipmentASN(): void {
    const navigationExtras: NavigationExtras = {
      state: {
        selectedRows: this.selectedRows
      }
    };
    this.router.navigate(['/process-shipment-asn'], navigationExtras);
  }

  setViewButton(rowData: any): boolean {
    if (rowData.node.key.startsWith('parent')) {
      return true
    }
    else {
      return false
    }
  }


  onClickSchedule(rowNode: any) {
    this.selectedPOData = [rowNode.node.data];
    this.selectedPOScheduleData = [];
    this.po_no = rowNode.node.data.plant;

    rowNode.node.children.forEach((child: any) => {
      this.selectedPOScheduleData.push(child.data);
    });

    this.sidebarVisible = true;
  }

  onGlobalSearch(event: any) {
    if (event?.target?.value) {
      const searchText = event.target.value;
      this.tt?.filterGlobal(searchText, 'contains');
    }
  }

  getSeverity(status: string): string {
    if (!status) {
      return 'info';
    }

    switch (status) {
      case 'Open':
        return 'openforSchedule';
      case 'Open for Schedule':
        return 'openforSchedule';
      case 'Open for Delivery':
        return 'openforDelivery';
      case 'Partial Delivered':
        return 'partialDelivered';
      case 'Delivered':
        return 'delivered';
      case 'Shipment Pending':
          return 'shipmentpending';
      case 'Shipment Created':
          return 'shipmentcreated';

      default:
        return 'info';
    }
  }

  getSeverityClass(severity: string): string {
    switch (severity) {
      case 'openforSchedule':
        return 'openforSchedule';
      case 'openforDelivery':
        return 'openforDelivery';
      case 'partialDelivered':
        return 'partialDelivered';
      case 'delivered':
        return 'delivered';
      case 'shipmentpending':
          return 'shipmentpending';
      case 'shipmentcreated':
          return 'shipmentcreated';
      default:
        return '';
    }
  }

  shipmentPendingAndCreated(index:number){
    this.mappedData= []
    this.scheduleSearchDTO={}
    this.itemSearchDTO={}
    this.poSearchDTO={}
    if (index === 1) {
      this.isShipmentPendingMap=true
      this.isShipmentCreatedMap=false
    }else if (index === 2) {
      this.isShipmentCreatedMap=true
      this.isShipmentPendingMap=false
    }
    this.allFetchData()
  }
}
